import { Button, Grid, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import React from "react";
import * as Yup from "yup";
import FormikTextField from "../../../../../commons/formik/FormikTextField";
import { StyledDomicilio } from "../../../../../styled/Empresa";

const validationSchema = Yup.object().shape({
  calle: Yup.string().required("Este campo es obligatorio"),
  numero: Yup.string().required("Este campo es obligatorio"),
  provincia: Yup.string().required("Este campo es obligatorio"),
  localidad: Yup.string().required("Este campo es obligatorio"),
  codigoPostal: Yup.string().required("Este campo es obligatorio"),
  piso: Yup.string().required("Este campo es obligatorio"),
});

const DomicilioCard = ({ data }) => {
  const initialValues = {
    calle: data.calle?.nombre || "Sin Información",
    numero: data.calle?.numero || "Sin Información",
    provincia: data.provincia?.nombre || "Sin Información",
    localidad: data.localidad?.nombre || "Sin Información",
    codigoPostal: data.calle?.codigoPostal || "Sin Información",
    piso:
      data.piso?.valor + " " + data.departamento?.valor || "Sin Información",
  };

  const handleSumbit = (data) => { };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSumbit}
    >
      {({ errors, touched }) => (
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <StyledDomicilio.FormikInput>
                <Typography>Provincia</Typography>
                <FormikTextField
                  id="provincia"
                  name="provincia"
                  type="text"
                  disabled={true}
                  FormHelperTextProps={{
                    sx: {
                      display: "none",
                    },
                  }}
                />
                <StyledDomicilio.ErrorDiv>
                  {touched.provincia && errors.provincia && (
                    <Typography variant="caption" sx={{ color: "red" }}>
                      {errors.provincia}
                    </Typography>
                  )}
                </StyledDomicilio.ErrorDiv>
              </StyledDomicilio.FormikInput>
              <StyledDomicilio.FormikInput>
                <Typography>Calle</Typography>
                <FormikTextField
                  id="calle"
                  name="calle"
                  type="text"
                  disabled={true}
                  FormHelperTextProps={{
                    sx: {
                      display: "none",
                    },
                  }}
                />
                <StyledDomicilio.ErrorDiv>
                  {touched.calle && errors.calle && (
                    <Typography variant="caption" sx={{ color: "red" }}>
                      {errors.calle}
                    </Typography>
                  )}
                </StyledDomicilio.ErrorDiv>
              </StyledDomicilio.FormikInput>
              <StyledDomicilio.FormikInput>
                <Typography>Piso / Dto</Typography>
                <FormikTextField
                  id="piso"
                  name="piso"
                  type="text"
                  disabled={true}
                  FormHelperTextProps={{
                    sx: {
                      display: "none",
                    },
                  }}
                />
                <StyledDomicilio.ErrorDiv>
                  {touched.piso && errors.piso && (
                    <Typography variant="caption" sx={{ color: "red" }}>
                      {errors.piso}
                    </Typography>
                  )}
                </StyledDomicilio.ErrorDiv>
              </StyledDomicilio.FormikInput>
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", flexDirection: "column" }}
            >
              <StyledDomicilio.FormikInput>
                <Typography>Localidad</Typography>
                <FormikTextField
                  id="localidad"
                  name="localidad"
                  type="text"
                  disabled={true}
                  FormHelperTextProps={{
                    sx: {
                      display: "none",
                    },
                  }}
                />
                <StyledDomicilio.ErrorDiv>
                  {touched.localidad && errors.localidad && (
                    <Typography variant="caption" sx={{ color: "red" }}>
                      {errors.localidad}
                    </Typography>
                  )}
                </StyledDomicilio.ErrorDiv>
              </StyledDomicilio.FormikInput>
              <StyledDomicilio.FormikInput>
                <Typography>Nro</Typography>
                <FormikTextField
                  id="numero"
                  name="numero"
                  type="text"
                  disabled={true}
                  FormHelperTextProps={{
                    sx: {
                      display: "none",
                    },
                  }}
                />
                <StyledDomicilio.ErrorDiv>
                  {touched.numero && errors.numero && (
                    <Typography variant="caption" sx={{ color: "red" }}>
                      {errors.numero}
                    </Typography>
                  )}
                </StyledDomicilio.ErrorDiv>
              </StyledDomicilio.FormikInput>
              <StyledDomicilio.FormikInput>
                <Typography>Código Postal</Typography>
                <FormikTextField
                  id="codigoPostal"
                  name="codigoPostal"
                  type="text"
                  disabled={true}
                  FormHelperTextProps={{
                    sx: {
                      display: "none",
                    },
                  }}
                />
                <StyledDomicilio.ErrorDiv>
                  {touched.codigoPostal && errors.codigoPostal && (
                    <Typography variant="caption" sx={{ color: "red" }}>
                      {errors.codigoPostal}
                    </Typography>
                  )}
                </StyledDomicilio.ErrorDiv>
              </StyledDomicilio.FormikInput>
            </Grid>
          </Grid>
          <StyledDomicilio.ButtonContainer>
            <Button type="submit" disabled={true}>
              Guardar
            </Button>
          </StyledDomicilio.ButtonContainer>
        </Form>
      )}
    </Formik>
  );
};

export default DomicilioCard;
